import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/lazy';
import Footer from '../common/Footer'
import Header from '../common/Header'
import { Link } from 'react-router-dom'
import promocodeshero from "../../images/promo-codes-hero-img-1.2.webp";
import btnleftshap from "../../images/btn-left-shap.webp";
import btnrightshap from "../../images/btn-right-shap.webp";
import postauthorname from "../../images/testimonialsuser.png";
import stockmarketpost01 from "../../images/stock-market-img01.png";
import stockmarketpost02 from "../../images/stock-market-img02.png";
import stockmarketpost03 from "../../images/stock-market-img03.png";
// import youtubeVideo from "../images/video-cover-how-to-start-1.webp";
// import { Dropdown } from 'react-bootstrap';

const Blogs = () => {
  let base_image_url = process.env.REACT_APP_IMAGE_URL;
  const [langcode, setLangcode] = useState(
    JSON.parse(localStorage.getItem("langcode")) || {
      Code: "en",
      Name: "English",
    }
  );

  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = e => setMatches(e.matches);
      mql.addEventListener('change', handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener('change', handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery('(min-width: 1402px)');
  const wrapperRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [aboutpagedata, setAboutpagedata] = useState();
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };

    // Initial setup
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }

    // Add scroll and resize listeners
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);

  // Apply scroll effect to the wrapper
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);
  useEffect(() => {
    const handleStorageChange = () => {
      const newLangcode = localStorage.getItem("langcode");
      setLangcode(JSON.parse(newLangcode)); // Update the state when langcode changes
    };

    window.addEventListener("storage", handleStorageChange);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  return (
    <div className="home">
      <div className="main-page" ref={wrapperRef}>
        <Header />

        <section className="blogMainSec">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-12">
                <div className="blog-left-sidebar">
                  <h4 className="sidebar_title">News & Events</h4>
                  <ul className="eq-cat-group-links">
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Signals <span>2659</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        News <span>344</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Data <span>84</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Humor <span>4</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Events <span>2</span>
                      </Link>
                    </li>
                  </ul>

                  <h4 className="sidebar_title">Knowledge base</h4>
                  <ul className="eq-cat-group-links">
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Markets <span>1025</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Trading <span>820</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Calculators <span>4</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Regulation and safety <span>80</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Learning <span>620</span>
                      </Link>
                    </li>
                  </ul>

                  <h4 className="sidebar_title">Interesting</h4>
                  <ul className="eq-cat-group-links">
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Reviews <span>248</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Trading platforms <span>300</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Bonificaciones y promociones <span>10</span>
                      </Link>
                    </li>
                    <li className="eq-cat-group-item">
                      <Link to="">
                        Estrategias de Trading <span>150</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-9 col-md-8 col-sm-12">
                <div className="blogCenter_Col">
                  <div className="blogItem-one">
                    <div className="blog-dt-link">
                      <Link to="/blogdetals">
                        <img src={promocodeshero} alt="" />
                      </Link>
                    </div>
                    <div class="eq-banner__link-decor">
                      <Link to="" className="btn_onImg">
                        <img className="left0" src={btnleftshap} alt="" />
                        <span>Details <i class="fa-solid fa-arrow-right"></i></span>
                        <img className="right0" src={btnrightshap} alt="" />
                      </Link>
                    </div>
                  </div>

                  <div className="blogs-slider">
                    <div className="blogs-title-btn">
                      <h4 className="blog_title">Knowledge base</h4>
                      <Link to="/postcategory" className="btn bg_btn">View All <i class="fa-solid fa-arrow-right"></i></Link>
                    </div>

                    <Swiper
                      modules={[Navigation, Pagination, Autoplay]}
                      spaceBetween={10}
                      slidesPerView={1}
                      loop={true}
                      pagination={{ clickable: true }}
                      navigation
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      // lazy={true}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                    >
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost01} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost02} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost03} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost01} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    </Swiper>

                  </div>

                  <div className="liveVideo">
                    <h4 className="blog_title">LIVE</h4>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/7aAA7F-qILc?si=5sXRhQLxEtj5Tx-X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <div className="mt-3">
                      <p className="text-white">Begin your trading journey with Pocket Option using this comprehensive how to trade guide.</p>
                      <Link
                        to="https://www.youtube.com/@EqulixOfficial"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn bg_btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="rgba(230,38,38,1)"><path d="M12.2439 4C12.778 4.00294 14.1143 4.01586 15.5341 4.07273L16.0375 4.09468C17.467 4.16236 18.8953 4.27798 19.6037 4.4755C20.5486 4.74095 21.2913 5.5155 21.5423 6.49732C21.942 8.05641 21.992 11.0994 21.9982 11.8358L21.9991 11.9884L21.9991 11.9991C21.9991 11.9991 21.9991 12.0028 21.9991 12.0099L21.9982 12.1625C21.992 12.8989 21.942 15.9419 21.5423 17.501C21.2878 18.4864 20.5451 19.261 19.6037 19.5228C18.8953 19.7203 17.467 19.8359 16.0375 19.9036L15.5341 19.9255C14.1143 19.9824 12.778 19.9953 12.2439 19.9983L12.0095 19.9991L11.9991 19.9991C11.9991 19.9991 11.9956 19.9991 11.9887 19.9991L11.7545 19.9983C10.6241 19.9921 5.89772 19.941 4.39451 19.5228C3.4496 19.2573 2.70692 18.4828 2.45587 17.501C2.0562 15.9419 2.00624 12.8989 2 12.1625V11.8358C2.00624 11.0994 2.0562 8.05641 2.45587 6.49732C2.7104 5.51186 3.45308 4.73732 4.39451 4.4755C5.89772 4.05723 10.6241 4.00622 11.7545 4H12.2439ZM9.99911 8.49914V15.4991L15.9991 11.9991L9.99911 8.49914Z"></path></svg>
                      VISIT OUR YOUTUBE CHANNEL</Link>
                    </div>
                  </div>
                  
                  <div className="blogs-slider">
                    <div className="blogs-title-btn">
                      <h4 className="blog_title">Interesting</h4>
                      <Link to="" className="btn bg_btn" href="#">View All <i class="fa-solid fa-arrow-right"></i></Link>
                    </div>

                    <Swiper
                      modules={[Navigation, Pagination, Autoplay]}
                      spaceBetween={10}
                      slidesPerView={1}
                      loop={true}
                      pagination={{ clickable: true }}
                      navigation
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      // lazy={true}
                      breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                    >
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost01} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost02} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost03} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="blog_item_card">
                          <img className="post-card-picture" src={stockmarketpost01} alt="" />
                          <Link to="" className="post-link-a">
                            <div className="post-category">Trading platforms</div>
                            <div className="post-meta">
                              <div className="post-meta-date">18 August 2025</div>
                              <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                            </div>
                            <div className="post-author-dt">
                              <img src={postauthorname} alt="" />
                              <span className="post-author-name">Carolina Silva</span>
                            </div>
                            <div className="post-info">
                              <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                              <div className="post-overlay-text">
                                Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                              </div>
                            </div>
                            <div className="post-default-actions">
                              <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                              <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    </Swiper>

                  </div>

                  <div className="blogTopics-card">
                    <h4 className="blog_title">Blog topics</h4>
                    <ul className="blogTopics-list">
                      <li className="blogTopics-item"><Link to="">signal</Link></li>
                      <li className="blogTopics-item"><Link to="">investment</Link></li>
                      <li className="blogTopics-item"><Link to="">stock</Link></li>
                      <li className="blogTopics-item"><Link to="">strategy</Link></li>
                      <li className="blogTopics-item"><Link to="">platform</Link></li>
                      <li className="blogTopics-item"><Link to="">beginner</Link></li>
                      <li className="blogTopics-item"><Link to="">crypto</Link></li>
                      <li className="blogTopics-item"><Link to="">how</Link></li>
                      <li className="blogTopics-item"><Link to="">currency</Link></li>
                      <li className="blogTopics-item"><Link to="">indicator</Link></li>
                      <li className="blogTopics-item"><Link to="">pattern</Link></li>
                      <li className="blogTopics-item"><Link to="">trading</Link></li>
                      <li className="blogTopics-item"><Link to="">demo</Link></li>
                      <li className="blogTopics-item"><Link to="">AI</Link></li>
                      <li className="blogTopics-item"><Link to="">intraday</Link></li>
                      <li className="blogTopics-item"><Link to="">leverage</Link></li>
                      <li className="blogTopics-item"><Link to="">app</Link></li>
                      <li className="blogTopics-item"><Link to="">bot</Link></li>
                      <li className="blogTopics-item"><Link to="">copy</Link></li>
                      <li className="blogTopics-item"><Link to="">withdraw</Link></li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        
        <Footer />
      </div>
    </div>
  )
}

export default Blogs
